import { faroCoreApiClient } from "@api/faro-core-api-client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Fetch current user */
export const fetchCurrentUser = createAsyncThunk<
  FaroCoreApiTypes.LoggedInUser,
  void
>("user/fetchCurrentUser", () => {
  return faroCoreApiClient.users.getLoggedInUser();
});

/** Fetch current user roles */
export const fetchCurrentUserRoles = createAsyncThunk<
  FaroCoreApiTypes.AdmUserRole[],
  void
>("user/fetchCurrentUserRoles", () => {
  return faroCoreApiClient.admin.getUserRoles();
});
